module.exports = __webpack_public_path__ + "img/classitem.6d55f8d0.png";